module.exports = __webpack_public_path__ + "img/two_leakalerts.1009412a.jpg";